import React from "react";
import { Card, Col, Row, Table, Typography } from "antd";
import { PAGINATION } from "../../../admin/_redux/constants";
import {
  TIME_FORMAT_WITHOUT_DATE,
  TIME_FORMAT_WITHOUT_TIME
} from "../../../app/_redux/constants";
import dayjs from "dayjs";
import _ from "lodash";
import { DEFAULT_VALUE } from "../../../app/_redux/constants";
import { capitalizeAllProperNouns } from "../../../../../core/helpers/utils";

const { Text } = Typography;
function TripodDailyLog({ total, loading, dataSource, param, onChangeParam }) {
  const CARD_STYLE = {
    borderRadius: "0.42rem",
    boxShadow: "0px 0px 30px 0px rgba(82, 63, 105, 0.05)"
  };
  const CARD_BODY_STYLE = {
    padding: "0px 10px 10px 10px"
  };
  const CARD_HEAD_STYLE = {
    padding: "0px 9px 0px 9px",
    borderBottom: "none"
  };
  const SNoStyle = {
    color: "#14a05b",
    fontWeight: "bold",
    display: "inline-block",
    textAlign: "center"
  };
  const columns = [
    {
      dataIndex: "stt",
      title: "STT",
      width: "3%",
      align: "center"
    },
    {
      dataIndex: "time",
      title: "Ngày",
      width: "8%",
      align: "center",
      render: time =>
        time ? dayjs(time).format(TIME_FORMAT_WITHOUT_TIME) : DEFAULT_VALUE
    },
    {
      dataIndex: "profile_id",
      title: "ID nhân viên",
      width: "8%",
      align: "center",
      render: profile_id => profile_id || DEFAULT_VALUE
    },
    {
      dataIndex: "username",
      title: "Username",
      width: "8%",
      align: "center",
      render: username => username || DEFAULT_VALUE
    },
    {
      title: "Tên nhân viên",
      dataIndex: "fullname",
      width: "8%",
      align: "center",
      render: fullname => capitalizeAllProperNouns(fullname) || DEFAULT_VALUE
    },
    {
      title: "Tên kho",
      dataIndex: "station_id",
      width: "10%",
      render: (text, dailyLog) => {
        return (
          <Text>
            <span style={SNoStyle}>
              {_.get(dailyLog, "station_id", DEFAULT_VALUE)}
            </span>
            {" | " + `${_.get(dailyLog, "station_name", DEFAULT_VALUE)}`}
          </Text>
        );
      }
    },
    {
      title: "Phòng ban",
      dataIndex: "department",
      width: "8%",
      align: "center",
      render: department => department || DEFAULT_VALUE
    },
    {
      dataIndex: "checkin_time",
      title: "Checkin",
      width: "8%",
      align: "center",
      render: checkin_time =>
        checkin_time
          ? dayjs(checkin_time).format(TIME_FORMAT_WITHOUT_DATE)
          : DEFAULT_VALUE
    },
    {
      dataIndex: "checkout_time",
      title: "Checkout",
      width: "8%",
      align: "center",
      render: checkout_time =>
        checkout_time
          ? dayjs(checkout_time).format(TIME_FORMAT_WITHOUT_DATE)
          : DEFAULT_VALUE
    }
  ];
  return (
    <Card
      size="small"
      style={CARD_STYLE}
      bodyStyle={CARD_BODY_STYLE}
      headStyle={CARD_HEAD_STYLE}
      title={
        <Row align="middle" gutter={[8]} justify="start">
          <Col>
            <Text>
              Tổng số log: <Text className="text-dark">{total}</Text>
            </Text>
          </Col>
        </Row>
      }
    >
      <Table
        loading={{
          spinning: loading,
          delay: 500
        }}
        rowKey="_id"
        bordered
        size="small"
        columns={columns}
        dataSource={dataSource}
        pagination={{
          pageSize: param.size,
          current: param.page,
          defaultPageSize: PAGINATION.page,
          total,
          showSizeChanger: true,
          onChange: (page, pageSize) => {
            onChangeParam({
              page: page,
              size: pageSize
            });
          }
        }}
      />
    </Card>
  );
}

export default React.memo(TripodDailyLog);
